import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { CopyUrl } from '@components/CopyUrl';
import { APIKongVX, KollectionType } from '@cyberkongz/api-interfaces';
import { Kong } from '@cyberkongz/database';
import {
  HeartIcon,
  KongActionIcon,
  kongActionTooltipStyles,
  Modal,
  pxToRem,
  SHARED_ROUTES,
  ShareIcon,
  Viewer3DIcon,
} from '@cyberkongz/ui';
import { useChainEnhanced, useKongVXEnhancedData } from '@cyberkongz/ui-blockchain';
import { useSharedUI } from '@features/sharedUI/SharedUIProvider';
import { useRouter } from 'next/router';

import { DownloadActionForm } from './DownloadActionForm';
import { EditActionForm } from './EditActionForm';
import { EvolveIncubator } from './EvolveIncubator';
import { TransferActionForm } from './TransferActionForm';

// TO DO IMPLEMENT LATER ON
function LikeKongAction() {
  return (
    <KongActionIcon onClick={() => window.alert('Like kong')} label="Favourite">
      <Flex css={{ alignItems: 'center', gap: 2 }}>
        <HeartIcon />
        <Box>3</Box>
      </Flex>
    </KongActionIcon>
  );
}

function ViewerAction() {
  const { open: isOpen, onOpen, onClose } = useDisclosure();
  const { kongVXTheme } = useSharedUI();
  const { query } = useRouter();

  return (
    <>
      <KongActionIcon onClick={onOpen} label="3D Viewer">
        <Viewer3DIcon color={kongVXTheme?.text} />
      </KongActionIcon>
      {isOpen ? (
        <Modal size="full" isOpen={isOpen} onClose={onClose} styles={{ body: { p: 0 } }}>
          <iframe
            src={SHARED_ROUTES.VIEWER(query.id as string)}
            style={{ width: '100%', height: '100vh' }}
          />
        </Modal>
      ) : null}
    </>
  );
}

export function NonConnectedActions({ type }: { type?: KollectionType }) {
  const { kongVXTheme } = useSharedUI();

  return (
    <>
      <CopyUrl
        icon={
          <KongActionIcon label="Share">
            <ShareIcon color={kongVXTheme?.text} />
          </KongActionIcon>
        }
        sxMessageBox={{
          ...kongActionTooltipStyles,
          w: '7em',
          top: 0,
          left: '50%',
          transform: 'translate(-50%,-110%)',
        }}
      />
      {type === 'vx' ? <ViewerAction /> : null}
    </>
  );
}

export function ConnectedActions({ type }: { type?: KollectionType }) {
  return (
    <>
      <NonConnectedActions type={type} />
    </>
  );
}

export function OwnerActions({ kong, type }: { kong: Kong | APIKongVX; type: KollectionType }) {
  const { chain } = useChainEnhanced();
  const isVX = type === 'vx';
  const isIncubator = type === 'baby' ? (kong as Kong).stage === 0 : false;
  const { chain: vxChain } = useKongVXEnhancedData(isVX ? (kong as APIKongVX) : undefined);
  const { kongVXTheme } = useSharedUI();

  return (
    <>
      <ConnectedActions type={type} />
      <Box css={{ bg: kongVXTheme?.text || 'text', w: pxToRem(1), h: 6, mx: 4 }} />
      {isVX || chain?.type === 'mainnet' ? <TransferActionForm kong={kong} type={type} /> : null}
      {(isVX && vxChain === 'mainnet') || !isVX ? <EditActionForm kong={kong} type={type} /> : null}
      {isVX ? <DownloadActionForm {...{ kong, type }} /> : null}
      {isIncubator ? <EvolveIncubator kong={kong as Kong} /> : null}
    </>
  );
}
